import { useEffect, useState } from "react";
import Api from "../../services/api";
import { NFTExport } from "../../models/exports";

export const useGetWalletNFTs = (address: string) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>();
  const [walletNFTs, setWalletNFTs] = useState<NFTExport[]>();

  const api = new Api();

  const getAllNFTs = (cursor, calledNfts) =>
    api
      .getWalletNfts({ address, cursor })
      .then((resp) => {
        let combinedNfts = calledNfts.concat(resp.data.assets);
        //If we get a next field, it means we have more to load since api can only handle batches of 50
        if (resp.data.next) {
          return getAllNFTs(resp.data.next, combinedNfts);
        } else {
          return combinedNfts;
        }
      })
      .catch((err) => {
        console.log(err);
        setError(err);
      });

  useEffect(() => {
    getAllNFTs("", [])
      .then((response) => {
        setWalletNFTs(response);
      })
      .catch((error) => {
        console.log(error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return [walletNFTs, loading, error];
};
